import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {TrendModule} from '@/views/system/trends/interfaces';
import {EntityModule} from './entities/entityModule';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import enumsModule from '@/store/modules/enumsModule';
import {getEventData, getEventTypes, getLastEvents} from '@/store/modules/entities/pmodules/base';

/*
    Динамический модуль хранилища vuex для Трендов
*/

const moduleName = 'trendtaskStoreModule';

function transformGet(elem: any): TrendModule {
  return {
    id: elem.id,
    guid: elem.guid,
    name: elem.name,
    description: elem.description,
    type: elem.type,
    parent_pm: elem.parent_pm,
    module_type: elem.module_type,
    module_guid: elem.module_guid,
    module_name: pmoduleModule.all.find(x => x.guid == elem.module_guid)?.name,
    event_name: elem.event_name,
    field_name: elem.field_name,
    start_date: elem.start_date,
    trend_type: elem.trend_type,
    interval: elem.interval,
    inverse_data: elem.inverse_data,
    is_monotone: elem.is_monotone,
    min_border_value: elem.min_border_value,
    measurements: elem.measurements,
  };
}

function transformGetById(elem: any): TrendModule {
  return transformGet(elem);
}

function transformCreateEdit(elem: any): TrendModule {
  return {
    guid: elem.guid,
    name: elem.name,
    description: elem.description,
    type: elem.type,
    parent_pm: elem.parent_pm,
    module_type: elem.module_type,
    module_guid: elem.module_guid,
    event_name: elem.event_name,
    field_name: elem.field_name,
    start_date: elem.start_date,
    trend_type: elem.trend_type,
    interval: elem.interval,
    inverse_data: elem.inverse_data,
    is_monotone: elem.is_monotone,
    min_border_value: elem.min_border_value,
    measurements: elem.measurements,
  };
}

function transformSave(model: TrendModule): any {
  return {
    id: model.id,
    guid: model.guid,
    name: model.name,
    description: model.description,
    type: model.type,
    parent_pm: model.parent_pm,
    module_type: model.module_type
      ? model.module_type
      : enumsModule.moduleTypes.find(
          mt => mt.value == pmoduleModule.all.find(x => x.guid == model.module_guid)?.type,
        )?.url,
    module_guid: model.module_guid,
    event_name: model.event_name ? model.event_name : 'value_changed',
    field_name: model.field_name,
    start_date: model.start_date,
    trend_type: model.trend_type,
    interval: model.interval,
    inverse_data: model.inverse_data,
    is_monotone: model.is_monotone,
    min_border_value: model.min_border_value,
    measurements: model.measurements,
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class TrendTaskStoreModule extends EntityModule {
  protected routeName = 'signal-trend-tasks';

  get all(): TrendModule[] {
    const full_list = (super.all as TrendModule[]).slice();
    return full_list.sort((a, b) => a.name.localeCompare(b.name));
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    await pmoduleModule.fetchAll();
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: TrendModule}> {
    return super.create(transformCreateEdit) as Promise<{data: TrendModule}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: TrendModule}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: TrendModule}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: TrendModule) {
    return super.save(model, transformSave);
  }

  //Получение объекта по идентификатору
  @Action
  async getById(id: any): Promise<{data: TrendModule}> {
    return super.getById(id, transformGetById) as Promise<{data: TrendModule}>;
  }

  //Получение типов событий
  @Action
  async getEventTypes(): Promise<any> {
    try {
      return await getEventTypes(this.routeName);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение списка последних событий
  @Action
  async getLastEvents(params: {id: number; eventType: string; limit?: number}): Promise<any> {
    try {
      return await getLastEvents(this.routeName, params);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение данных события
  @Action
  async getEventData(params: {id: number; eventType: string; timestamp: number}): Promise<any> {
    try {
      return await getEventData(this.routeName, params);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export default getModule(TrendTaskStoreModule);
